import { render, staticRenderFns } from "./we.vue?vue&type=template&id=0a953254&scoped=true&"
import script from "./we.vue?vue&type=script&lang=js&"
export * from "./we.vue?vue&type=script&lang=js&"
import style0 from "./we.vue?vue&type=style&index=0&id=0a953254&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a953254",
  null
  
)

export default component.exports